// PgList.jsx
import React, { useEffect, useRef, useState } from "react";
import Pagination from "../../Components/Pagination/Pagination.jsx";
import "../Users/style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import "jspdf-autotable";
import "sweetalert2/dist/sweetalert2.min.css";
import { getAccommodations, getAccommodationsMap, getTenant,  } from "../../utils/api.js";
import { isEmpty, pdfData } from "../../utils/common.js";
import LocalLoader from "../../Components/Loader/LocalLoader.js";
import { FilterWrapper } from "../../assets/styles/FilterStyle.js";

import animationData1 from "../../assets/lotties/question.json";
import { TableWrapper } from "../../Components/styledConstant.js";
import { useSelector } from "react-redux";
import { AlertWrapper } from "../../Components/Modal/style.js";
import ConfirmBox from "../../Components/ConfirmBox/ConfirmBox.jsx";

import MoreOptions from "../../Components/MoreOptions/MoreOptions.jsx";
import TenantKyc from "./TenantKyc.jsx";
import AutoSuggestion from "../../Components/AutoSuggest/AutoSuggest.js";

require("react-datepicker/dist/react-datepicker.css");

const PgList = () => {
  const [apiData, setApiData] = useState([]);

  const [totalPages, setTotalPages] = useState(null);
  const [totalElements, setTotalElements] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pdfData_, setPdfData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [mobileNumber, setMobileNumber] = useState("");
  const [status, setStatus] = useState("");
  const [userData, setUserData] = useState("");
    const [accommodations, setAccommodations] = useState([]);
    const [filterAcc, setfilterAcc] = useState([]);
      const [showSuggestion,setShowSuggestion] = useState(false);
 const [accommodationId,setAccommodationId] = useState(undefined);
  const [searchTerm,setSearchTerm] = useState("")
  const [loginUserType, setLoginUserTye] = useState("");
  const [showfilter, setShowFilter] = useState("");

  const [sidebar, setSidebar] = useState(null)

  const navigate = useNavigate();
  const link = useRef();
    const autoSuggestionRef = useRef(null);

  const location = useLocation();
  const { mobileNumber:number } = location.state || {};

  useEffect(() => {
    if (number) {
      setUserData(number);
      navigate(location.pathname, { replace: true });
    }
  }, [number]);

  const handleApiData = async (key, params) => {
    if (key === "CSV") {
      setDownloadLoader("CSV");
    } else if (key === "PDF") {
      setDownloadLoader("PDF");
    } else {
      setDownloadLoader("");
      setLoading(true);
    }

    getAccommodations(params?.pageNo,params?.accommodationId).then((resp) => {
      setLoading(false);
      setDownloadLoader("");

      if (resp?.data.message === "SUCCESS") {
        if (key === "CSV") {
          setPdfData(resp?.data?.data?.content);
          setTimeout(() => {
            const csvlink = link.current;
            csvlink.link.click();
          }, 100);
        } else if (key === "PDF") {
          userlistPdfData(resp?.data?.data?.content);
        } else {
          setCurrPage(params?.pageNo);
          setApiData(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
        }
      }
    });
  };

  useEffect(() => {
    const params = {
      mobileNumber: "",
      status: "",
      pageNo: 0,
      accommodationId:accommodationId,
    };
    handleApiData("", params);
     handleGetAccommodations();
  }, []);

  const currentPage = (page) => {
    const params = {
      mobileNumber: mobileNumber,
      status: status,
      pageNo: page,
      accommodationId:accommodationId
    };
    handleApiData("", params);
    setCurrPage(page);
  };

  const userlistPdfData = (data = []) => {
    pdfData(data, [], "B2C-User-List", 400);
  };

  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (loginUserType === "" && !isEmpty(user?.userType)) {
      setLoginUserTye(user?.userType);
    }
  }, [user]);


  useEffect(() => {
    if (isEmpty(message)) return;
    const timerId = setTimeout(() => {
      setMessage({});
    }, 5000);
    return () => clearTimeout(timerId);
  }, [message]);

  const search = () => {
    handleApiData("", {
      mobileNumber: mobileNumber,
      status: status,
      pageNo: 0,
      accommodationId:accommodationId,
    });
    console.log("accommodationId",{
      mobileNumber: mobileNumber,
      status: status,
      pageNo: 0,
      accommodationId:accommodationId,
  })
    setCurrPage(0);
  };

  const refresh = () => {
    handleApiData("", {
      mobileNumber: "",
      status: "",
      pageNo: 0,
      accommodationId:undefined
    });
    setMobileNumber("");
    setStatus("");
    setCurrPage(0);
    setAccommodationId(undefined);
    setSearchTerm("")
  };

 const moreOptions = [
  {
    label: "PG Details",
    click: (item) =>{
     setSidebar(item)
    }
     ,
    show: () => true,
  },
   {
    label: "Edit PG Details",
    click: (item) =>{
      navigate("/Add-pg", { state: item });
    }
     ,
    show: () => true,
  },
];

  function filterByNameOrAddress(list, searchText) {
  if (!searchText) return list;

  const query = searchText.toLowerCase();

 

  return list.filter(item =>
    item.name.toLowerCase().includes(query) ||
    item.address.toLowerCase().includes(query)
  );
}


  const handleGetAccommodations = async () => {
   
    getAccommodationsMap(0).then((resp) => {
      setLoading(false);
    
  console.log("accommodations",resp)
      if (resp?.data.message === "SUCCESS") {
      
          setAccommodations(resp?.data?.data || []); 
          setfilterAcc(resp?.data?.data || []); 
        
      }
    });
  };

    const handleInputChange = (e) =>{
                     setAccommodationId(undefined);
                      setSearchTerm(e.target.value);
          
                
             const filterData =  filterByNameOrAddress(accommodations,e.target.value);
              setfilterAcc([...filterData])
  }

   const handleChange = (item) =>{
      setAccommodationId(item?.id);
      setShowSuggestion(false);
      setSearchTerm(item?.name);
  }
  

  
  const randerIdem = (item,index) =>{
    
    return(
        <li key={index} onClick={() =>handleChange(item)}>
                <div className="flex justify-between pd-10-0">
                  <div className="flex gap-15 items-center">
                   
                    <div className="flex column gap-5">
                      <span className="fs-13 fw-500 cursor">{item?.name}</span>
                      <label className="fs-10 fw-400 cursor color_grey">
                        {item?.address}
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-10 items-center cursor">
                    <span className="fs-12 fw-600">{location?.code}</span>
                  </div>
                </div>
              </li>
    )
  }

 
  return (
    <>
    

      {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="userlisthead_container">
        <div style={{ padding: "30px" }}>
          <div className="transaction_main_container">
            <div className="userlist_head">
              <div className="userlist_heading">
                <div className="userlist_left">
                  <label>PG List</label>
                </div>
                <div className="userlist_right">
                  {downloadLoader !== "PDF" ? (
                    <button
                      className="pdf"
                      onClick={() =>
                        handleApiData("PDF", {
                          mobileNumber: mobileNumber,
                          status: status,
                          pageNo: 0,
                          accommodationId:accommodationId,
                        })
                      }
                    >
                      PDF
                    </button>
                  ) : (
                    <button className="pdf">
                      <div className="btn-loader">
                        <i className="fa-solid fa-spinner"></i>
                      </div>
                    </button>
                  )}
                  {downloadLoader !== "CSV" ? (
                    <button
                      className="xls"
                      onClick={() =>
                        handleApiData("CSV", {
                          mobileNumber: mobileNumber,
                          status: status,
                          pageNo: 0,
                          accommodationId:accommodationId,
                        })
                      }
                    >
                      CSV
                    </button>
                  ) : (
                    <button className="xls">
                      <div className="btn-loader">
                        <i className="fa-solid fa-spinner"></i>
                      </div>
                    </button>
                  )}
                  <CSVLink
                    ref={link}
                    data={pdfData_}
                    filename="B2C-User-List.csv"
                  ></CSVLink>
                </div>
                <div className="userlist_filter">
                  <button
                    className="filter fs-16"
                    onClick={() =>
                      showfilter === "active"
                        ? setShowFilter("")
                        : setShowFilter("active")
                    }
                  >
                    <i className="fa-solid fa-filter"></i>
                  </button>
                </div>
              </div>
            </div>
            <FilterWrapper
              style={{ height: "auto" }}
              className={`display_data ${showfilter}`}
            >
              <div className="grow-0">
                <div className="grow-1">
                  <div className="flex align-items gap-15">
                    <div style={{position:"relative"}} ref={autoSuggestionRef}>
                    <input
                      type="text"
                      name="accommodations"
                      placeholder="Search Accommodation"
                     value={searchTerm}
                     onFocus={()=>setShowSuggestion(true)}
                     onChange={handleInputChange}
                    
                    
                    />
                    {showSuggestion && (
              <div >
                 <AutoSuggestion
    fromCityList={filterAcc || []}
    setCityName={(name) =>{}}
    setCityId={(id) =>{}}
   
    setShowCity={()=>{}}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
    randerItem={randerIdem}
  />
              
              </div>
)}
                  </div>
                    <div>
                      <button
                        className="userlist_btn"
                        onClick={search}
                        style={{ width: "100px" }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="button">
                      <button
                        className="refresh-btn"
                        style={{ width: "60px" }}
                        onClick={refresh}
                      >
                        <i className="fa fa-refresh"></i>
                      </button>
                    </div>
                    <div>
                      <button
                        className="userlist_btn"
                        onClick={() => navigate("/Add-pg")}
                        style={{ width: "100px" }}
                      >
                        Add PG
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </FilterWrapper>
          </div>

          {apiData && (
            <div className="table-loader">
              {loading && <LocalLoader className="tableLoader" />}
              <TableWrapper className="table-card-wrapper">
                <table className="table">
                  <thead>
                    <tr> 
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Address</th>
                      <th>Locality</th>
                      <th>Postal Code</th>
                      <th>Owner Name</th>
                      <th>Owner Parent Name</th>
                      <th>Contact</th>
                      <th>Police Station</th>
                      <th>State</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiData &&
                      apiData.map((item, index) => (
                        <tr key={index}>
                          <td>{currPage * pageSize + index + 1}</td>
                          <td>{item?.name || "-"}</td>
                          <td>{item?.city || "-"}</td>
                          <td>{item?.state || "-"}</td>
                          <td>{item?.addressLine || "-"}</td>
                          <td>{item?.locality || "-"}</td>
                          <td>{item?.postalCode || "-"}</td>
                          <td>{item?.ownerName || "-"}</td>
                          <td>{item?.ownerParentName || "-"}</td>
                          <td>{item?.contactNumber || "-"}</td>
                          <td>{item?.policeStation || "-"}</td>
                           <td>
                              <span className="card-th">Status</span>
                              <span>
                                <div
                                  className={`${
                                    item.status?"active_status":"inactive_status"
                                      
                                      
                                  }`}
                                >
                                  {item?.status === undefined?"-":item?.status?"ACTIVE":"INACTIVE"}
                                </div>
                              </span>
                            </td>
                          <td>
                            <MoreOptions options={moreOptions} items={item} />
                          </td>
                        </tr>
                      ))}
                    {!loading && apiData.length < 1 && (
                      <tr>
                        <td colSpan={11} style={{ textAlign: "center", color: "red" }}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </TableWrapper>
            </div>
          )}

          {totalPages > 1 && (
            <Pagination
              items={apiData}
              itemsPerPage={pageSize}
              setitemsPerPage={setPageSize}
              currentPage={currPage}
              setcurrentPage={(page) => currentPage(page)}
              totalPages={totalPages}
              forcePage={currPage}
            />
          )}
        </div>

        
    {  sidebar &&  <TenantKyc close={()=>setSidebar(null)} pgData={sidebar} />}
      </div>
    </>
  );
};

export default PgList;
